import i18n from 'i18n/config';

export const stopOrderTriggersMap = {
  mark_price: i18n.t('trading:markPrice'),
  last_traded_price: i18n.t('trading:lastPrice'),
  spot_price: i18n.t('trading:indexPrice'),
};
